

































import { useStampStore } from '@/store/stamp';
import { defineComponent, computed } from '@vue/composition-api';
import ToCouponsBtnVue from '../stamp-module/to-coupons-btn.vue';
import { useHalfStamp } from '@/hooks/use-half-stamp';
import SvgIcon from '@/components/common/svg-icon.vue';
import { storeToRefs } from 'pinia';
import { i18n } from '@/i18n';
import { useRecordNewFeatureNotice } from '@/store/record';
import { biClick } from '@tencent/fit-bi-sdk';

export default defineComponent({
  components: {
    ToCouponsBtnVue,
    SvgIcon,
  },
  setup() {
    /** 印花结余 */
    const { remainCount } = storeToRefs(useStampStore());

    /** 点击拉起“印花卡” */
    const { showHalfStamp } = useHalfStamp();

    const remainCountAriaLabel = computed(() =>  `${i18n('印花结馀')} ${remainCount.value}`);

    const recordNewFeatureNoticeStore = useRecordNewFeatureNotice();
    const { isRead } = storeToRefs(recordNewFeatureNoticeStore);

    const handleGoToRecord = () => {
      biClick('header-module.stampRecord_click|印花记录入口点击');
    };

    return {
      remainStamp: remainCount,
      remainCountAriaLabel,
      viewMoreStamp: showHalfStamp,
      isRead,
      handleGoToRecord,
    };
  },
});
